export const GET_CADERNOS_ENCARGOS = "GET_CADERNOS_ENCARGOS";
export const SET_CADERNOS_ENCARGOS = "SET_CADERNOS_ENCARGOS";

export const getCadernosEncargos = () => ({
  type: GET_CADERNOS_ENCARGOS,
});

export const setCadernosEncargos = (cadernosEncargosAllList) => ({
  type: SET_CADERNOS_ENCARGOS,
  cadernosEncargosAllList,
});
export const SET_CREATED_CADERNO_ENCARGO = "SET_CREATED_CADERNO_ENCARGO";
export const setCreateEncargo = (show, msg) => {
  return { type: SET_CREATED_CADERNO_ENCARGO, show, msg };
};

export const CREATE_NEW_CADERNO_ENCARGOS = "CREATE_NEW_CADERNO_ENCARGOS";
export const SET_NEW_CADERNO_ENCARGOS = "SET_NEW_CADERNO_ENCARGOS";

export const setNewCadernoEncargos = (cadernoEncargosData) => ({
  type: SET_NEW_CADERNO_ENCARGOS,
  cadernoEncargosData,
});
export const createNewCadernoEncargos = (payload) => {
  return {
    type: CREATE_NEW_CADERNO_ENCARGOS,
    payload,
  };
};

export const ERROR_CADERNO_ENCARGOS = "ERROR_CADERNO_ENCARGOS";
export const errorCadernoEncargos = (error, message) => ({
  type: ERROR_CADERNO_ENCARGOS,
  error,
  message,
});

export const GET_CVS = "GET_CVS";
export const SET_CVS = "SET_CVS";
export const getCvs = () => ({
  type: GET_CVS,
});
export const setCvs = (cvAllList) => ({
  type: SET_CVS,
  cvAllList,
});

export const GET_SPECIFIC_CV = "GET_SPECIFIC_CV";
export const SET_SPECIFIC_CV = "SET_SPECIFIC_CV";
export const getSpecificCv = (id) => ({
  type: GET_SPECIFIC_CV,
  id,
});
export const setSpecificCv = (cv) => ({
  type: SET_SPECIFIC_CV,
  cv,
});
export const UPDATED_CV = "UPDATED_CV";
export const updateCv = (payload) => {
  return {
    type: UPDATED_CV,
    payload,
  };
};
export const SET_UPDATED_CV = "SET_UPDATED_CV";
export const setUpdateCv = (show, msg) => {
  return { type: SET_UPDATED_CV, show, msg };
};

export const SET_CREATED_CV = "SET_CREATED_CV";
export const setCreatedCv = (show, msg) => {
  return { type: SET_CREATED_CV, show, msg };
};

export const CREATE_NEW_CV = "CREATE_NEW_CV";
export const SET_NEW_CV = "SET_NEW_CV";

export const setNewCvs = (cvData) => ({
  type: SET_NEW_CV,
  cvData,
});
export const createNewCVS = (payload) => {
  return {
    type: CREATE_NEW_CV,
    payload,
  };
};
export const ERROR_CV = "ERROR_CV";
export const errorCVS = (error, message) => ({
  type: ERROR_CV,
  error,
  message,
});

export const GENERATE_CV_PROMPT = "GENERATE_CV_PROMPT";
export const SET_GENERATE_CV_PROMPT = "SET_GENERATE_CV_PROMPT";
export const generateCVPrompt = (items, desc) => {
  return { type: GENERATE_CV_PROMPT, items, desc };
};
export const setGenerateCVPrompt = (cvPrompt) => ({
  type: SET_GENERATE_CV_PROMPT,
  cvPrompt,
});

export const SET_SAVE_CV_MGR_LOADING = "SET_SAVE_CV_MGR_LOADING";
export const setSaveCvMgrLoading = (loading) => {
  return { type: SET_SAVE_CV_MGR_LOADING, loading };
};

export const GET_SPECIFIC_ENCARGO = "GET_SPECIFIC_ENCARGO";
export const SET_SPECIFIC_ENCARGO = "SET_SPECIFIC_ENCARGO";
export const getSpecificEncargo = (id) => ({
  type: GET_SPECIFIC_ENCARGO,
  id,
});
export const setSpecificEncargo = (encargo) => ({
  type: SET_SPECIFIC_ENCARGO,
  encargo,
});
export const UPDATED_ENCARGO = "UPDATED_ENCARGO";
export const updateEncargo = (payload) => {
  return {
    type: UPDATED_ENCARGO,
    payload,
  };
};
export const SET_UPDATED_ENCARGO = "SET_UPDATED_ENCARGO";
export const setUpdateEncargo = (show, msg) => {
  return { type: SET_UPDATED_ENCARGO, show, msg };
};

export const GET_PROFILES_BY_ENCARGO = "GET_PROFILES_BY_ENCARGO";
export const SET_PROFILES_BY_ENCARGO = "SET_PROFILES_BY_ENCARGO";
export const getProfilesByEncargo = (encargo) => ({
  type: GET_PROFILES_BY_ENCARGO,
  encargo,
});

export const setProfilesByEncargo = (profiles) => ({
  type: SET_PROFILES_BY_ENCARGO,
  profiles,
});
